import { render, staticRenderFns } from "./AdminAddAgent.vue?vue&type=template&id=2b23fae9&scoped=true&"
import script from "./AdminAddAgent.vue?vue&type=script&lang=js&"
export * from "./AdminAddAgent.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddAgent.vue?vue&type=style&index=0&id=2b23fae9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b23fae9",
  null
  
)

export default component.exports